module.exports = __webpack_public_path__ + "img/Loam.343c6915.png";